import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Box, Button, Text } from '@betty/moonlight';
import { DuplicateAccountsBottomSheetProps } from './DuplicateAccountsBottomSheet.types';

function DuplicateAccountsBottomSheet({
  close,
}: DuplicateAccountsBottomSheetProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleContactSupport = useCallback(() => {
    navigation.navigate('MiscScreen', { path: '/contact' });
    close();
  }, [navigation, close]);

  const handleLogin = useCallback(() => {
    navigation.navigate('LoginScreen');
    close();
  }, [navigation, close]);

  return (
    <Box>
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        locKey="duplicateAccountsLabel"
        locNS="registration"
      />
      <Box gap="space-400" marginTop="space-400">
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          locKey="duplicateAccountsDescription"
          locNS="registration"
        />
        <Box flexDirection="row" justifyContent="space-between" gap="space-200">
          <Button
            variant="primary"
            flex={1}
            locKey="duplicateAccountContactSupportButton"
            locNS="registration"
            onPress={handleContactSupport}
          />
          <Button
            variant="secondary"
            flex={1}
            locKey="duplicateAccountLoginButton"
            locNS="registration"
            onPress={handleLogin}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(DuplicateAccountsBottomSheet);
